'use client';

import Image from 'next/image';
import { useState } from 'react';
import { Button } from './ui/button';
import { SendHorizonalIcon, XIcon } from 'lucide-react';
import { Input } from './ui/input';
import SmartImage from './SmartImage';
import { isMobileDevice } from '@/lib/utils';

export default function WhatsAppChatBubble() {
  const [openChat, setOpenChat] = useState(false);
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    const phoneNumber = '9008503073409';
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    if (isMobileDevice()) {
      window.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <div
      className="fixed right-5 z-50 pointer-events-auto"
      style={{
        bottom:
          'calc(1.25rem + env(safe-area-inset-bottom, 0px) + var(--hzc-vv-bottom-inset, 0px))',
      }}
    >
      {!openChat && (
        <Button
          onClick={() => setOpenChat(!openChat)}
          className="bg-hzc_beige_100 p-4 rounded-full shadow-lg hover:scale-105 transition-all duration-300 gap-2 items-center text-hzc_beige_900 border-hzc_beige_400"
        >
          <svg width="20" viewBox="0 0 24 24">
            <defs></defs>
            <path
              fill="#eceff1"
              d="M20.5 3.4A12.1 12.1 0 0012 0 12 12 0 001.7 17.8L0 24l6.3-1.7c2.8 1.5 5 1.4 5.8 1.5a12 12 0 008.4-20.3z"
            ></path>
            <path
              fill="#4caf50"
              d="M12 21.8c-3.1 0-5.2-1.6-5.4-1.6l-3.7 1 1-3.7-.3-.4A9.9 9.9 0 012.1 12a10 10 0 0117-7 9.9 9.9 0 01-7 16.9z"
            ></path>
            <path
              fill="#fafafa"
              d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z"
            ></path>
          </svg>
          WhatsApp
        </Button>
      )}

      {openChat && (
        <div className="w-full max-w-96 bg-white shadow-lg rounded-lg relative">
          <div className="flex items-center bg-[#0a5e54] p-4 rounded-t-lg">
            <div className="size-12 rounded-full bg-white items-center flex justify-center">
              <SmartImage
                src="/ic_hzc_purple.png"
                alt="Hızlı Çiçek Logo"
                className="size-8"
                width={50}
                height={50}
                imageType="icon"
              />
            </div>
            <div className="ml-2">
              <p className="font-bold text-base text-hzc_beige_100">Hızlı Çiçek</p>
              <p className="text-sm  text-hzc_beige_100">
                Genellikle 1 saat içerisinde yanıt verir.
              </p>
            </div>
          </div>

          <div className="relative py-8 bg-[#e6ddd4]">
            <SmartImage
              className="opacity-20 absolute w-full h-full top-0 bottom-0 object-cover"
              src="/whatsapp-background.png"
              alt="Hızlı Çiçek Whatsapp Arkaplan"
              fill
            />
            <div className="w-fit ml-6 rounded-lg rounded-tl-none my-1 p-2 text-sm bg-white flex flex-col relative speech-bubble-left">
              <p className="text-sm font-semibold">Hızlı Çiçek</p>
              <p className="text-sm">Merhaba, 🌸</p>
              <p className="text-sm">Size nasıl yardımcı olabiliriz?</p>
              <p className="text-gray-600 text-xs text-right leading-none">11:32</p>
            </div>
          </div>

          <div className="flex items-center p-2">
            <Input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Buraya yazınız"
              className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm"
            />
            <Button
              onClick={handleSendMessage}
              className="ml-2 bg-green-500 p-2 rounded-full text-white hover:bg-green-600 transition duration-200"
            >
              <SendHorizonalIcon />
            </Button>
          </div>

          <Button
            onClick={() => setOpenChat(false)}
            variant="ghost"
            className="absolute top-2 right-2 text-hzc_beige_100 hover:text-gray-600 size-8 p-2"
          >
            <XIcon />
          </Button>
        </div>
      )}
    </div>
  );
}
